import { useEffect, useState } from "react";
import paLogo from "@/assets/pa-logo.png";

interface OverlayTransitionProps {
  /** increments to trigger a new transition */
  trigger: number;
}

/**
 * Short black -> white curtain used when opening the light-themed overlays
 * (projects / case). Gives content time to mount before it is revealed.
 */
export const OverlayTransition = ({ trigger }: OverlayTransitionProps) => {
  const [phase, setPhase] = useState<"idle" | "dark" | "light" | "out">("idle");

  useEffect(() => {
    if (!trigger) return;
    setPhase("dark");
    const t1 = window.setTimeout(() => setPhase("light"), 60);
    const t2 = window.setTimeout(() => setPhase("out"), 620);
    const t3 = window.setTimeout(() => setPhase("idle"), 1050);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, [trigger]);

  if (phase === "idle") return null;

  const isLight = phase !== "dark";

  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 z-[500] flex items-center justify-center"
      style={{
        backgroundColor: isLight ? "#FFFFFF" : "#000000",
        opacity: phase === "out" ? 0 : 1,
        transition:
          "background-color 520ms cubic-bezier(0.2, 0.8, 0.2, 1), opacity 420ms cubic-bezier(0.2, 0.8, 0.2, 1)",
        pointerEvents: phase === "out" ? "none" : "auto",
        willChange: "opacity, background-color",
      }}
    >
      <img
        src={paLogo}
        alt=""
        width={110}
        height={110}
        className="w-[22vw] max-w-[110px] min-w-[70px]"
        style={{
          filter: isLight ? "invert(1)" : "invert(0)",
          transform: `scale(${phase === "out" ? 1.05 : 1})`,
          transition:
            "filter 520ms cubic-bezier(0.2, 0.8, 0.2, 1), transform 900ms cubic-bezier(0.2, 0.8, 0.2, 1)",
        }}
      />
    </div>
  );
};
